module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1547.420a2f69.jpg";